<template>
  <section class="hero">
    <img src="@/assets/school-building.png" alt="校园建筑" class="bg-image">
    <div class="overlay"></div>
    <div class="container">
      <div class="hero-content">
        <h1>广校通智筑校园新生态</h1>
        <p class="subtitle">深耕家校共育 厚植文化建设 助力学子成长</p>
        <div class="hero-features">
          <span>
            <img src="@/assets/icon-shield.png" alt="" class="feature-icon">
            安全守护
          </span>
          <span>
            <img src="@/assets/icon-smart.png" alt="" class="feature-icon">
            智能交互
          </span>
          <span>
            <img src="@/assets/icon-data.png" alt="" class="feature-icon">
            数据驱动
          </span>
          <span>
            <img src="@/assets/icon-open.png" alt="" class="feature-icon">
            开放融合
          </span>
        </div>
        <a href="#" class="btn-primary">合作咨询 | 020-82038386</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppBanner'
}
</script>

<style scoped>
.hero {
  position: relative;
  width: 100%;
  /* 移除 aspect-ratio，改用固定高度或视口单位 */
  height: 600px;  /* 或 60vh */
  /* aspect-ratio: 1920 / 920;  删除这行 */
  overflow: hidden;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 关键：调整焦点到底部，确保建筑完整显示 */
  object-position: center bottom;  
  /* 或者：object-position: center 40%;  数值越大越靠下 */
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 3;
  max-width: 600px;
  /* 调整内边距，确保文字在合适位置 */
  padding: 120px 20px 40px;  /* 上边距加大，下边距减小 */
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(255, 255, 255, 0.3); */
  z-index: 2;
}

.hero-content {
  position: relative;
  z-index: 3;
  max-width: 600px;
  padding: 80px 20px 100px;
}

.hero h1 {
  font-size: 52px;
  color: #1a1a1a;
  margin-bottom: 20px;
  font-weight: bold;
  letter-spacing: 2px;
}

.subtitle {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-bottom: 36px;
  letter-spacing: 2px;
}

.hero-features {
  display: flex;
  gap: 24px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.hero-features span {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  color: #555;
}

.feature-icon {
  width: 24px;
  height: 24px;
}

.btn-primary {
  display: inline-block;
  background: #02a9fa;
  color: #fff;
  padding: 12px 32px;
  border-radius: 25px;
  font-size: 16px;
  text-decoration: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>